/**
 * Genera e imprime (PDF) una requisición de pedido o de recepción.
 * Abre una nueva ventana con el HTML formateado y dispara window.print().
 */
export function imprimirRequisicion(req: any, config?: { restaurante?: string; logo?: string }) {
  const restaurante = config?.restaurante || 'CHARGOY';
  const esPedido    = req.tipo === 'pedido';
  const titulo      = esPedido ? 'REQUISICIÓN DE PEDIDO' : 'REQUISICIÓN DE RECEPCIÓN';
  const fecha       = new Date(req.created_at).toLocaleString('es-MX', {
    day: '2-digit', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });

  const filas = (req.items || []).map((item: any, i: number) => {
    const recibida  = item.cantidad_recibida != null
      ? Number(item.cantidad_recibida).toLocaleString('es-MX', { maximumFractionDigits: 3 })
      : '—';
    const diferencia = item.cantidad_recibida != null
      ? Number(item.cantidad_recibida) - Number(item.cantidad_pedida)
      : null;
    const diffColor = diferencia === null ? '' :
                      diferencia < 0      ? 'color:#dc2626' :
                      diferencia > 0      ? 'color:#16A34A' : '';
    const diffStr   = diferencia === null ? '—' :
                      (diferencia > 0 ? '+' : '') +
                      diferencia.toLocaleString('es-MX', { maximumFractionDigits: 3 });

    return `
      <tr style="background:${i % 2 === 0 ? '#fff' : '#f9fafb'}">
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb">${i + 1}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;font-weight:500">${item.insumo_nombre}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;text-align:right">
          ${Number(item.cantidad_pedida).toLocaleString('es-MX', { maximumFractionDigits: 3 })}
        </td>
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;text-align:center">${item.unidad}</td>
        ${!esPedido ? `
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;text-align:right">${recibida}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;text-align:right;${diffColor}">${diffStr}</td>
        ` : ''}
        <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;color:#666;font-size:12px">${item.notas || ''}</td>
      </tr>`;
  }).join('');

  const columnasPedido = `
    <th style="${th}">Cant. pedida</th>
    <th style="${th}text-align:center">Unidad</th>
    <th style="${th}">Observaciones</th>`;

  const columnasRecepcion = `
    <th style="${th}">Cant. pedida</th>
    <th style="${th}text-align:center">Unidad</th>
    <th style="${th}">Cant. recibida</th>
    <th style="${th}">Diferencia</th>
    <th style="${th}">Observaciones</th>`;

  const firmaPedido = `
    <div style="margin-top:60px;display:grid;grid-template-columns:1fr 1fr;gap:48px">
      <div style="border-top:1px solid #374151;padding-top:8px;text-align:center">
        <p style="font-size:11px;color:#666;margin:0">Solicitado por</p>
        <p style="font-size:11px;margin:4px 0 0">${req.usuario_nombre}</p>
      </div>
      <div style="border-top:1px solid #374151;padding-top:8px;text-align:center">
        <p style="font-size:11px;color:#666;margin:0">Autorizado por</p>
        <p style="font-size:11px;margin:4px 0 0">&nbsp;</p>
      </div>
    </div>`;

  const firmaRecepcion = `
    <div style="margin-top:60px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:32px">
      <div style="border-top:1px solid #374151;padding-top:8px;text-align:center">
        <p style="font-size:11px;color:#666;margin:0">Recibido por</p>
        <p style="font-size:11px;margin:4px 0 0">${req.usuario_nombre}</p>
      </div>
      <div style="border-top:1px solid #374151;padding-top:8px;text-align:center">
        <p style="font-size:11px;color:#666;margin:0">Verificado por</p>
        <p style="font-size:11px;margin:4px 0 0">&nbsp;</p>
      </div>
      <div style="border-top:1px solid #374151;padding-top:8px;text-align:center">
        <p style="font-size:11px;color:#666;margin:0">Proveedor / Entregó</p>
        <p style="font-size:11px;margin:4px 0 0">&nbsp;</p>
      </div>
    </div>`;

  const html = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>${titulo} — ${req.id?.slice(0,8).toUpperCase()}</title>
  <style>
    @page { size: letter portrait; margin: 18mm 15mm; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
    * { box-sizing: border-box; }
    body { font-family: Arial, sans-serif; font-size: 13px; color: #111; margin: 0; }
    table { width: 100%; border-collapse: collapse; }
  </style>
</head>
<body>
  <!-- Encabezado -->
  <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px">
    <div>
      <h1 style="font-size:22px;font-weight:700;color:#DC2626;margin:0 0 4px">${restaurante}</h1>
      <h2 style="font-size:15px;font-weight:700;color:#374151;margin:0;text-transform:uppercase;letter-spacing:1px">${titulo}</h2>
    </div>
    <div style="text-align:right">
      <p style="font-size:11px;color:#6b7280;margin:0">Folio</p>
      <p style="font-size:14px;font-weight:700;color:#111;margin:2px 0">#${req.id?.slice(0,8).toUpperCase()}</p>
      <p style="font-size:11px;color:#6b7280;margin:4px 0 0">${fecha}</p>
    </div>
  </div>

  <!-- Info del documento -->
  <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:8px;padding:12px 16px;margin-bottom:20px;display:flex;gap:40px">
    <div>
      <p style="font-size:10px;color:#6b7280;margin:0 0 2px;text-transform:uppercase;font-weight:600">Solicitante</p>
      <p style="font-size:13px;font-weight:600;margin:0">${req.usuario_nombre}</p>
    </div>
    <div>
      <p style="font-size:10px;color:#6b7280;margin:0 0 2px;text-transform:uppercase;font-weight:600">Estado</p>
      <p style="font-size:13px;font-weight:600;margin:0;text-transform:capitalize">${req.estado}</p>
    </div>
    ${!esPedido && req.pedido_usuario ? `
    <div>
      <p style="font-size:10px;color:#6b7280;margin:0 0 2px;text-transform:uppercase;font-weight:600">Pedido original por</p>
      <p style="font-size:13px;font-weight:600;margin:0">${req.pedido_usuario}</p>
    </div>` : ''}
    ${!esPedido ? `
    <div>
      <p style="font-size:10px;color:#6b7280;margin:0 0 2px;text-transform:uppercase;font-weight:600">Aplicado a inventario</p>
      <p style="font-size:13px;font-weight:600;margin:0;color:${req.aplicada_inventario ? '#16A34A' : '#6b7280'}">${req.aplicada_inventario ? '✓ Sí' : 'No'}</p>
    </div>` : ''}
    ${req.notas ? `
    <div>
      <p style="font-size:10px;color:#6b7280;margin:0 0 2px;text-transform:uppercase;font-weight:600">Notas</p>
      <p style="font-size:13px;margin:0">${req.notas}</p>
    </div>` : ''}
  </div>

  <!-- Tabla de items -->
  <table>
    <thead>
      <tr style="background:#DC2626">
        <th style="${th}color:#fff;width:36px">#</th>
        <th style="${th}color:#fff;text-align:left">Insumo / Artículo</th>
        ${esPedido ? columnasPedido : columnasRecepcion}
      </tr>
    </thead>
    <tbody>${filas}</tbody>
  </table>

  <!-- Total items -->
  <p style="font-size:11px;color:#9ca3af;margin:10px 0 0;text-align:right">${req.items?.length || 0} artículo(s)</p>

  <!-- Firmas -->
  ${esPedido ? firmaPedido : firmaRecepcion}
</body>
</html>`;

  const win = window.open('', '_blank', 'width=850,height=1100');
  if (!win) { alert('Permite ventanas emergentes para imprimir'); return; }
  win.document.write(html);
  win.document.close();
  win.onload = () => {
    win.focus();
    win.print();
  };
}

// Estilo base de th
const th = 'padding:9px 10px;font-size:12px;font-weight:600;text-align:right;';
